function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Path_1021",
  "data-name": "Path 1021",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 11.5 22 C 5.710279941558838 22 1 17.28972053527832 1 11.5 C 1 5.710279941558838 5.710279941558838 1 11.5 1 C 17.28972053527832 1 22 5.710279941558838 22 11.5 C 22 17.28972053527832 17.28972053527832 22 11.5 22 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 11.5 2 C 6.261680603027344 2 2 6.261680603027344 2 11.5 C 2 16.73831939697266 6.261680603027344 21 11.5 21 C 16.73831939697266 21 21 16.73831939697266 21 11.5 C 21 6.261680603027344 16.73831939697266 2 11.5 2 M 11.5 0 C 17.85127067565918 0 23 5.14872932434082 23 11.5 C 23 17.85127067565918 17.85127067565918 23 11.5 23 C 5.14872932434082 23 0 17.85127067565918 0 11.5 C 0 5.14872932434082 5.14872932434082 0 11.5 0 Z",
  stroke: "none",
  fill: "#e3400d"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_148",
  "data-name": "Group 148",
  transform: "translate(9.42 3.679)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_117",
  "data-name": "Rectangle 117",
  width: 2.16,
  height: 7.19,
  transform: "translate(1 2)",
  fill: "#e3400d"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_118",
  "data-name": "Rectangle 118",
  width: 2.16,
  height: 2.16,
  transform: "translate(1 11.481)",
  fill: "#e3400d"
}));

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.8222fced.svg";
export { ForwardRef as ReactComponent };